import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TemplateBuilderService } from '@app/main/template-editor/services/template-builder.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-template-editor-side-bar',
    templateUrl: './template-editor-side-bar.component.html',
    styleUrls: ['./template-editor-side-bar.component.scss'],
    standalone: false
})
export class TemplateEditorSideBarComponent {
    @Input() burgerOpen: boolean;
    @Input() builder: TemplateBuilderService;

    get formGroup(): UntypedFormGroup {
        return this.builder.formGroup;
    }

    get activeSectionIndex(): number {
        return this.builder.activeSection;
    }

    get sections(): UntypedFormArray {
        return this.formGroup.get('sections') as UntypedFormArray;
    }

    get currentLang(): string {
        return this.builder.currentEditingLang;
    }

    removeSection(index: number) {
        this.builder.removeSection(index);
    }

    setItem(index: number) {
        this.builder.setActiveEditSection(index);
        document.getElementById('section' + index).scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    getControl(item: AbstractControl, name: string): UntypedFormControl {
        return item.get(name + (this.currentLang === 'en' ? '' : 'De')) as UntypedFormControl;
    }

    drop(event: CdkDragDrop<string[]>): void {
        this.builder.reorder(event.previousIndex, event.currentIndex);
        this.setItem(event.currentIndex);
    }
}
